import { RootState } from "../../app/store";
import { authApi } from "./../authServices";
import { createSlice } from "@reduxjs/toolkit";

type AuthState = {
	user: any | null;
	token: string | null;
	emailToken: string | null
};

const profileSlice = createSlice({
	name: "profile",
	initialState: { user: null, token: null, emailToken: null } as AuthState,
	reducers: {


		token: (state, { payload }) => {

			state.user = null
			state.token = payload
		},
		logout(state) {
			state.token = null;
			state.user = null;
		},
		emailVerifyToken: (state, { payload }) => {
			state.user = null
			state.token = payload
		},
		updateToken: (state, { payload }) => {
			state.user = null
			state.emailToken = payload
		},
	},
	extraReducers: (builder) => {
		// builder.addMatcher(profileSlice.actions.emailVerifyToken.match, (state, { payload }) => {
		// 	authApi.endpoints.verifyEmail.initiate(
		// 	)


		// }),
		builder.addMatcher(
			authApi.endpoints.loginUser.matchFulfilled,
			(state, { payload }) => {

				payload = { ...payload }
				state.token = payload.token;
				state.user = payload.user;
			}
		);



	},
});

export const isToken = (state: RootState) => state.profile.token
export const { logout, emailVerifyToken, updateToken, token } = profileSlice.actions;
export default profileSlice.reducer;
